import { useLocation, useNavigate } from 'react-router-dom';

import Checkbox from 'components/checkbox';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import MeaningfulHeader from 'components/meaningful-header';

import useBoundStore from 'store';
import { BuyApartmentFlowPaths } from 'routes';
import useViewApartmentDealsButtonProps from 'hooks/use-view-apartment-deals-button-props';
import useApartmentsFilterLimitsOnboarding from 'api/hooks/use-apartment-filter-limits-onboarding';

import styles from './styles.module.scss';
import { removeZeroRoomApartments } from '../../lib/utils';

const ChooseNumberOfRooms: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedApartmentRoomTypes = useBoundStore((s) => s.selectedApartmentRoomTypes);
  const toggleSelectedApartmentRoomTypes = useBoundStore((s) => s.toggleSelectedApartmentRoomTypes);

  const { filterLimits } = useApartmentsFilterLimitsOnboarding();
  const selectedComplexes = useBoundStore((s) => s.selectedComplexes);

  const buttons: ButtonProps[] = [
    useViewApartmentDealsButtonProps(),
    {
      label: 'Продолжить',
      onClick: () =>
        navigate(
          selectedComplexes && selectedComplexes?.size > 1
            ? BuyApartmentFlowPaths.choosePriceRange
            : BuyApartmentFlowPaths.chooseApartmentPlan,
        ),
    },
  ];

  const transformedFirstlyTypes = filterLimits?.facilityTypes?.length
    ? removeZeroRoomApartments(filterLimits?.facilityTypes)?.map((i) => ({
        id: i.id,
        key: i.id,
        label: i.fullTitle,
      }))
    : [];

  return (
    <BaseScreen
      buttons={buttons}
      fixedContentHeight
      title='Подбор объектов'
      onBackButtonClick={() =>
        navigate(
          BuyApartmentFlowPaths.chooseApartmentComplex,
          location?.state?.prevScreen === 'map'
            ? {
                state: { prevUrl: 'buy/rooms-number' },
              }
            : undefined,
        )
      }
    >
      <MeaningfulHeader header='Количество комнат' motto='Доступные планировки' />

      <div className={styles.checkboxes}>
        {transformedFirstlyTypes.map(({ id, label }) => (
          <Checkbox
            key={id}
            label={label}
            labelPosition='left'
            className={styles.checkbox}
            checked={selectedApartmentRoomTypes.has(id)}
            onChange={() => toggleSelectedApartmentRoomTypes(id)}
          />
        ))}
      </div>
    </BaseScreen>
  );
};

export default ChooseNumberOfRooms;
